import { environment } from 'src/environment';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SettingsService, BaseService, StorageService } from 'src/app/core/services';
import { ChangePasswordService } from 'src/app/core/services/change-password.service';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { UikitService } from 'src/app/core/services/uikit.service';
import * as uikit from 'uikit';
import { BehaviorSubject } from 'rxjs';
import { LoggerService } from 'src/app/core/authentication/logger.service';
import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss', '../modal-screens.scss'],
  standalone: true,
  imports: [NgIf, NgClass, AsyncPipe, ReactiveFormsModule, FormsModule]
})
export class ChangePasswordComponent implements OnInit {

  changePasswordForm: any;
  showPassword = false;
  showConfirmPassword = false;
  showOldPassword = false;
  passwordType = 'password';
  passwordImg = 'branding/theme/assets/static_assets/ic-hide.svg';
  oldPasswordType = 'password';
  oldPasswordImg = 'branding/theme/assets/static_assets/ic-hide.svg';
  confirmPasswordType = 'password';
  confirmPasswordImg = 'branding/theme/assets/static_assets/ic-hide.svg';
  response: any;
  changePasswordData: any;
  skinName = environment.skinName;
  constructor(public settingsService: SettingsService, private formBuilder: FormBuilder,
    private changePasswordService: ChangePasswordService, public baseService: BaseService,
    private uikitService: UikitService, private storageService: StorageService, private loggerService: LoggerService,
    public configService: ConfigurationService, private router: Router, private analyticsService: InhouseAnalyticsService) {
    uikit.util.on(document, 'beforehide', '#change-password', () => {
      this.changePasswordForm.reset();
    });
  }

  ngOnInit(): void {
    this.changePasswordForm = this.formBuilder.group({
      old_password: ['', Validators.compose([Validators.required])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      password_confirmation: ['', Validators.compose([Validators.required, Validators.minLength(6)])]
    });
  }

  changePassword() {
    this.baseService.disableBuuton.next(true);
    this.changePasswordForm.markAllAsTouched();
    let successMsg = this.configService.localeKeys?.["account.login_to_continue.text"];
    const oldPass = this.changePasswordForm.get('old_password').value;
    const pass = this.changePasswordForm.get('password').value;
    const passConfirm = this.changePasswordForm.get('password_confirmation').value;
    let userId = this.storageService.getLocalStore('u_id');
    if (!userId) this.storageService.setLocalStore('a_t', this.loggerService.newAccessToken);
    if (this.changePasswordForm.valid && (pass == passConfirm)) {
      this.response = {
        old_password: oldPass,
        password: pass,
        password_confirmation: passConfirm,
        u_id: this.storageService.getLocalStore('u_id')
      };
      this.changePasswordService.changePasswordfun(this.response).subscribe({
        next: data => {
          this.changePasswordData = data;
          const eventObj = {
            event_type: 'event',
            event_name: 'Change Password',
            event_status: 'Success',
          };
          this.analyticsService.trackUserActions(eventObj);
        }, error: (err) => {
          const eventObj = {
            event_type: 'event',
            event_name: 'Edit Password',
            event_status: 'Failure',
            event_description: err.error?.error?.message
          };
          this.analyticsService.trackUserActions(eventObj);
        }, complete: () => {
          if (this.changePasswordData.status_code === 200) {
            this.baseService.disableBuuton.next(false);
            this.storageService.removeLocalStore('a_t');
            this.storageService.removeLocalStore('r_t');
            this.storageService.removeLocalStore('u_id');
            sessionStorage.removeItem('profileId');
            this.storageService.setLocalStore('logged_in', '0');
            this.storageService.removeLocalStore('sessionStorage');
            this.storageService.removeLocalStore('event_user_status');
            const loginMode = this.baseService.loginMode;
            if (loginMode === 1) {
              this.baseService.guestSource.next(true);
              this.router.navigateByUrl('/auth/signin');
            } else {
              this.baseService.guestSource.next(true);
              this.router.navigateByUrl('/home');
            }
            this.uikitService.staticSuccessMessage(successMsg);
            try {
              /*SPI-I387 issue fix start*/
              document.getElementById('change-password-hide')?.click();
              /*SPI-I387 issue fix end*/
              uikit.modal('#change-password').hide();
            } catch (error) {
              console.log(error)
            }
          } else {
            this.baseService.disableBuuton.next(false);
            if (!userId) this.storageService.setLocalStore('a_t', this.loggerService.oldAccessToken);
            this.uikitService.staticErrorMessage(this.changePasswordData.data.error.message);
          }
          if (this.changePasswordData.error && this.changePasswordData.error.code !== 1002) {
            this.baseService.disableBuuton.next(false);
            if (!userId) this.storageService.setLocalStore('a_t', this.loggerService.oldAccessToken);
            this.uikitService.staticErrorMessage(this.changePasswordData.error.message);
          }
          return false;
        }
      });
    }
  }


  // hidePassword() {
  //   this.showPassword = !this.showPassword;
  // if (this.showPassword) {
  //   this.passwordImg = 'branding/theme/assets/static_assets/ic-show.svg';
  //   this.passwordType = 'text';
  // } else {
  //   this.passwordImg = 'branding/theme/assets/static_assets/ic-hide.svg';
  //   this.passwordType = 'password'
  // }
  // }


  hidePassword(type) {
    if (type === 'password') {
      this.showPassword = !this.showPassword;
      if (this.showPassword) {
        this.passwordImg = 'branding/theme/assets/static_assets/ic-show.svg';
        this.passwordType = 'text';
      } else {
        this.passwordImg = 'branding/theme/assets/static_assets/ic-hide.svg';
        this.passwordType = 'password'
      }
    } else if (type === 'password_confirmation') {
      this.showConfirmPassword = !this.showConfirmPassword;
      if (this.showConfirmPassword) {
        this.confirmPasswordImg = 'branding/theme/assets/static_assets/ic-show.svg';
        this.confirmPasswordType = 'text';
      } else {
        this.confirmPasswordImg = 'branding/theme/assets/static_assets/ic-hide.svg';
        this.confirmPasswordType = 'password'
      }

    } else {
      this.showOldPassword = !this.showOldPassword;
      if (this.showOldPassword) {
        this.oldPasswordImg = 'branding/theme/assets/static_assets/ic-show.svg';
        this.oldPasswordType = 'text';
      } else {
        this.oldPasswordImg = 'branding/theme/assets/static_assets/ic-hide.svg';
        this.oldPasswordType = 'password'
      }
    }
  }


}
